<template>
  <div class="col-xl-9 col-lg-8">
    <div class="m-portlet m-portlet--full-height m-portlet--mobile">
      <div class="m-portlet__head">
        <div class="m-portlet__head-tools">
          <ul class="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary" role="tablist">
            <li class="nav-item m-tabs__item">
              <a class="nav-link m-tabs__link active" data-toggle="tab" href="#m_user_profile_tab_1" role="tab">
                <i class="flaticon-share m--hide"></i>
                {{ 'update_profile' | titleize }}
              </a>
            </li>
          </ul>
        </div>
        <div class="m-portlet__head-tools">
          <ul class="m-portlet__nav">
            <li class="m-portlet__nav-item">
              <a href="#" class="btn btn-success m-btn m-btn--icon" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#password_modal" @click="changeModalStatus(true)">
                <span>
                  <i class="fa fa-plus"></i>
                  <span>
                    {{ 'change_password' | capitalize }}
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane active" id="m_user_profile_tab_1">
          <form class="m-form m-form--fit m-form--label-align-right">
            <div class="m-portlet__body">
              <!-- <div class="form-group m-form__group m--margin-top-10 m--hide">
                <div class="alert m-alert m-alert--default" role="alert">
                  The example form below demonstrates common HTML form elements that receive updated styles from Bootstrap with additional classes.
                </div>
              </div> -->
              <div class="form-group m-form__group row">
                <label for="example-text-input" class="col-2 col-form-label">
                  {{ 'identification_number' | capitalize }}
                </label>
                <div class="col-7">
                  <input v-if="edit" v-model="user_data.identification_number" class="form-control m-input" type="number" readonly>
                  <span v-else class="form-control"> {{ user_data.identification_number }} </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label for="example-text-input" class="col-2 col-form-label">
                  {{ 'identification_type' | capitalize }}
                </label>
                <div class="col-7">
                  <input v-if="edit" v-model="user_data.identification_type.name" class="form-control m-input" type="text" readonly>
                  <span v-else class="form-control"> {{ user_data.identification_type.name }} </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label for="first_name" class="col-2 col-form-label">
                  {{ 'first_name' | capitalize }}
                </label>
                <div class="col-7" :class="{'has-danger': errors.has('first_name')}">
                  <input v-if="edit" id="first_name" type="text" v-model="user_data.first_name" name="first_name" class="form-control m-input" v-validate="'required|alpha_spaces|min:4|max:100'" >
                  <span v-else class="form-control"> {{ user_data.first_name }} </span>
                  <span v-show="errors.has('first_name')" class="m-form__help m--font-danger"> {{errors.first('first_name')}} </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label for="last_name" class="col-2 col-form-label">
                  {{ 'last_name' | capitalize }}
                </label>
                <div class="col-7" :class="{'has-danger': errors.has('last_name')}">
                  <input v-if="edit" id="last_name" v-model="user_data.last_name" name="last_name" class="form-control m-input" type="text" v-validate="'required|alpha_spaces|min:4|max:100'">
                  <span v-else class="form-control">{{ user_data.last_name }}</span>
                  <span v-show="errors.has('last_name')" class="m-form__help m--font-danger"> {{errors.first('last_name')}} </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label for="email" class="col-2 col-form-label">
                  {{ 'email' | capitalize }}
                </label>
                <div class="col-7" :class="{'has-danger': errors.has('email')}">
                  <input v-if="edit" id="email" v-model="user_data.email" name="email" class="form-control m-input" type="text" v-validate="'required|email|uniqueEmail'">
                  <span v-else class="form-control">{{ user_data.email }}</span>
                  <span v-show="errors.has('email')" class="m-form__help m--font-danger"> {{errors.first('email')}} </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label for="alternative_email" class="col-2 col-form-label">
                  {{ 'alternative_email' | capitalize }}
                </label>
                <div class="col-7" :class="{'has-danger': errors.has('alternative_email')}">
                  <input v-if="edit" id="alternative_email" v-model="user_data.alternative_email" name="alternative_email" class="form-control m-input" type="text" v-validate="'email|uniqueAlterEmail'" placeholder="Alternative Email (optional)">
                  <span v-else class="form-control">{{ user_data.alternative_email ? user_data.alternative_email : 'Alternative Email (optional)' }}</span>
                  <span v-show="errors.has('alternative_email')" class="m-form__help m--font-danger"> {{errors.first('alternative_email')}} </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label for="phone" class="col-2 col-form-label">
                  {{ 'phone_number' | capitalize }}
                </label>
                <div class="col-7" :class="{'has-danger': errors.has('first_name')}">
                  <input v-if="edit" id="phone" name="phone" v-model="user_data.telephone" class="form-control m-input" type="text" v-validate="'required|numeric|min:4|max:20'">
                  <span v-else class="form-control">{{ user_data.telephone }}</span>
                  <span v-show="errors.has('phone')" class="m-form__help m--font-danger"> {{errors.first('phone')}} </span>
                </div>
              </div>
            </div>
            <div class="m-portlet__foot m-portlet__foot--fit">
              <div class="m-form__actions">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-7">
                    <button @click.prevent="editUser" class="btn m-btn m-btn--air m-btn--custom" :class="edit ? 'btn-success' : 'btn-primary'">
                      {{ button_name | capitalize }}
                    </button>
                    &nbsp;&nbsp;
                    <a v-show="edit" @click.prevent="cancel" class="btn btn-secondary m-btn--air m-btn--custom">
                      {{ 'cancel' | capitalize }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <s-modal id="password_modal" :title="'change_password' | titleize">
            <s-password slot="body"></s-password>
          </s-modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import SModal from '@/components/layout/modal/Modal.vue'
import SPassword from '@/components/login/FormPassword.vue'

import axios from 'axios'
import { Validator } from 'vee-validate'
export default {
  components: { SModal, SPassword },
  data () {
    return {
      document_type: '',
      edit: false,
      button_name: 'edit',
      user_data: []
    }
  },
  created () {
    this.user_data = this.user
    this.uniqueEmail()
    this.uniqueAlterEmail()
  },
  methods: {
    editUser () {
      if (this.edit) {
        this.$spinner.show()
        this.$validator.validateAll()
          .then((result) => {
            if (result) {
              this.$spinner.remove()
              this.$confirmation()
                .then((res) => {
                  if (res.value) {
                    this.$spinner.show()
                    this.edit = false
                    this.button_name = 'edit'
                    this.$store.dispatch('getEditUser', this.user_data)
                      .then((res) => {
                        if (res.data) {
                          this.$spinner.remove()
                          this.$toast('edit_user_message')
                        } else {
                          this.$spinner.remove()
                          this.$toast('edit_user_error', 4)
                        }
                      })
                  }
                })
                .catch((err) => {
                  console.log(err)
                })
            }
            this.$spinner.remove()
          })
      } else {
        this.edit = true
        this.button_name = 'save'
      }
    },
    cancel () {
      this.edit = false
      this.button_name = 'save'
      this.$store.commit('setUserData', JSON.parse(localStorage.getItem('user_data')))
    },
    ...mapActions(['changeModalStatus']),

    uniqueEmail () {
      const uniqueEmail = (value) => {
        return axios.post('/api/user/check-email', { email: value, id: this.user_data.id, type: 1 })
          .then((response) => {
            return {
              valid: response.data.valid,
              data: {
                message: this.$options.filters.capitalize('email_already_exists')
              }
            }
          })
      }

      Validator.extend('uniqueEmail', {
        validate: uniqueEmail,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    },

    uniqueAlterEmail () {
      const uniqueAlterEmail = (value) => {
        return axios.post('/api/user/check-email', { email: value, id: this.user_data.id, type: 2 })
          .then((response) => {
            return {
              valid: response.data.valid,
              data: {
                message: this.$options.filters.capitalize('email_already_exists')
              }
            }
          })
      }

      Validator.extend('uniqueAlterEmail', {
        validate: uniqueAlterEmail,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    }
  },
  watch: {
    user () {
      this.user_data = this.user
    }
  },
  props: {
    user: { required: true }
  }
}
</script>



// WEBPACK FOOTER //
// ProfileContainer.vue